module.exports = __webpack_public_path__ + "09_face.73404143.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/09_face.png
// module id = VVgm
// module chunks = 0